import { ASSET, SUB_ASSETS } from '../configs/constants';
import { isFinanceQV } from '../utils';
import axios from '../../../configs/axios';

const {
  performance,
  widgets,
  audience,
  aso,
  finance_performance,
  finance_widgets,
  forecasts,
  advanced_time_series,
  app_details,
} = ASSET;

// App Assets
export const makeAppAssetList = (permissions) => {
  if (isFinanceQV(permissions)) {
    const assets = [finance_performance, finance_widgets];

    if (permissions.allowForecasts) {
      assets.push(forecasts);
    }

    if (permissions.allowFinanceAppOverviewV3) {
      assets.push(advanced_time_series);
    }

    return assets;
  }

  return [performance, widgets, audience, aso];
};

const getAppRequestStructure = ({ asset, filters, permissions }) => {
  let assetStructure = {};

  switch (asset) {
    // Finance
    case finance_performance:
      assetStructure = {
        assets: ['performance'],
        filters: {
          country_iso: ['WW'],
          ...filters,
        },
      };
      break;
    case finance_widgets:
      assetStructure = {
        assets: permissions.allowFinanceAppOverviewV3
          ? ['finance_insights', 'advanced_metrics_insights', 'metrics_insights']
          : ['finance_insights'],
        filters: {
          country_iso: ['WW'],
          ...filters,
        },
      };
      break;
    case forecasts:
      assetStructure = {
        assets: ['forecasts'],
        filters: {
          country_iso: ['WW'],
          ...filters,
        },
      };
      break;
    case advanced_time_series:
      assetStructure = {
        assets: ['advanced_time_series'],
        filters: {
          cohort: 'all_users',
          change_type: 'year_over_year',
          granularity: 'weekly',
          to_date_period: 'quarter',
          ...filters,
        },
      };
      break;
    // MSP
    case performance:
      assetStructure = {
        assets: ['time_series', 'country_breakdown'],
        filters: {
          country_iso: ['WW'],
          period: 30,
          countries_count: 3,
          ...filters,
        },
      };
      break;
    case widgets:
      assetStructure = {
        assets: ['insights', 'ranks'],
        filters: {
          country_iso: ['WW'],
          period: 30,
          countries_count: 3,
          ...filters,
        },
      };
      break;
    case audience:
      assetStructure = {
        assets: ['sentiments', 'intents'],
        filters: {
          country_iso: ['WW'],
          period: 30,
          ...filters,
        },
      };
      break;
    case aso:
      assetStructure = {
        assets: ['organic', 'paid'],
        filters: {
          country_iso: ['WW'],
          period: 30,
          ...filters,
        },
      };
      break;
    default:
      assetStructure = {};
  }

  return {
    assets: {
      [asset]: assetStructure,
    },
  };
};

const getAppDetailsStructure = detailsStore => ({
  assets: {
    [app_details]: {
      assets: SUB_ASSETS[app_details],
      filters: {
        country_iso: ['WW'],
        period: 30,
        store: detailsStore,
      },
    },
  },
});

export const fetchAppQuickview = ({ filters, asset, permissions }, params) => (
  axios.post(`/apps/${filters.store}/${filters.ref_no}/quick_view.json`, { request: getAppRequestStructure({ asset, filters, permissions }) }, params));

export const fetchAppQuickviewDetails = ({ store, ref_no, detailsStore }, params) => (
  axios.post(`/apps/${store}/${ref_no}/quick_view.json`, { request: getAppDetailsStructure(detailsStore) }, params));
